import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    card: {
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        margin: theme.spacing(4),
        width: '30rem',
    },
    cardMediaHidden: {
        margin: theme.spacing(4),
        width: '30rem',
        visibility: 'hidden',
    },
    media: {
        height: '140px',
    },
    sectionSeparator: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(4, 4, 2),
        width: '64rem', // Match the news banner width
        maxWidth: '100%',
    },
    separatorLine: {
        flex: 1,
        height: '1px',
        background: `linear-gradient(90deg, transparent 0%, rgba(27, 21, 74, 0.15) 20%, rgba(27, 21, 74, 0.3) 50%, rgba(27, 21, 74, 0.15) 80%, transparent 100%)`,
    },
    separatorLabel: {
        padding: theme.spacing(0, 3),
        color: theme.palette.primary.main,
        fontWeight: 600,
        fontSize: '1.1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: '50%',
            bottom: -2,
            transform: 'translateX(-50%)',
            width: '60%',
            height: '2px',
            background: `linear-gradient(90deg, transparent 0%, ${theme.palette.tertiary.main} 50%, transparent 100%)`,
        },
    },
}));
